import { Box, Fade, Grid } from '@mui/material';
import { BlocksActionHeaderTab } from 'components/BlocksList/BlocksActionPanel/BlocksActionHeaderTab';
import { BlocksImagesTab } from 'components/BlocksList/BlocksActionPanel/BlocksImagesTab';
import { ProcessingQueueTab } from 'components/BlocksList/BlocksActionPanel/ProcessingQueueTab';
import { blockActions } from 'components/BlocksList/constants';
import { useBlocksPageV2Styles } from 'components/BlocksList/styles';

export const BlocksActionPanel = ({
  processingQueue,
  setProcessingQueue,
  openBlocksModal,
  handleCreateOrder,
  activeTab,
  setActiveTab,
  selectedSamples,
  setSelectedSamples,
  selectedRows,
  selectedSlides,
  resetSelectedRows,
}) => {
  const { classes } = useBlocksPageV2Styles();
  const tabs = Object.keys(blockActions);

  const getTabCounter = (tab) => {
    switch (tab) {
      case blockActions.imageData:
        return selectedRows.length;
      case blockActions.processingQueue:
        return processingQueue.length;
      default:
        return 0;
    }
  };

  const activeTabKey = tabs.find((tab) => blockActions[tab] === activeTab);
  const activeIndex = tabs.indexOf(activeTabKey);
  const left = `${(activeIndex / tabs.length) * 100}%`;
  const width = `${100 / tabs.length}%`;
  const rowsHeight = tabs.map((tab, i) => (i === activeIndex ? 'auto' : 0));
  const gridTemplateRows = `min-content ${rowsHeight.join(' ')}`;

  return (
    <Grid
      item
      xs={4}
      className={classes.imagesWrapper}
      sx={{ gridTemplateRows }}
    >
      <Box className={classes.tabs}>
        {tabs.map((tab) => (
          <BlocksActionHeaderTab
            tab={tab}
            key={tab}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            getTabCounter={getTabCounter}
          />
        ))}
        <Box className={classes.tabsSlider} style={{ left, width }} />
      </Box>
      <Fade in={activeTab === blockActions.imageData} timeout={600}>
        <Box className={classes.imagesTab}>
          <BlocksImagesTab
            selectedSamples={selectedRows}
            selectedSlides={selectedSlides}
            resetSelectedRows={resetSelectedRows}
          />
        </Box>
      </Fade>
      <Fade in={activeTab === blockActions.processingQueue} timeout={600}>
        <Box className={classes.imagesTab}>
          <ProcessingQueueTab
            processingQueue={processingQueue}
            setProcessingQueue={setProcessingQueue}
            openBlocksModal={openBlocksModal}
            handleCreateOrder={handleCreateOrder}
            selectedSamples={selectedSamples}
            setSelectedSamples={setSelectedSamples}
          />
        </Box>
      </Fade>
    </Grid>
  );
};
